import { Injectable } from '@angular/core';
import { SloObservationDetails } from 'src/app/model/observation/slo/slo-details.model';
import { SloPerformanceIndicator } from 'src/app/model/observation/slo/slo-performance-indicator.model';
import { SloPerformanceMeasure } from 'src/app/model/observation/slo/slo-performance-measure.model';
import { SloApi } from '../../api/slo.api';

@Injectable()
export class SloObservationService {

  constructor(private sloApi: SloApi) { }

  getObservationDetails = (observationId: string) =>
    this.sloApi.getObservationDetails(observationId);

  createSlo = (observation: SloObservationDetails) =>
    this.sloApi.createSlo(observation);

  //hooks
  saveSLO = (slo: SloObservationDetails) =>
    this.sloApi.saveSLO(slo);
  completeInitial = (observation: SloObservationDetails) =>
    this.sloApi.completeInitial(observation);
  completeFinalization = (observation: SloObservationDetails) =>
    this.sloApi.completeFinalization(observation);
  approve = (observation: SloObservationDetails) =>
    this.sloApi.approve(observation);
  requestUpdate = (observationId: string) =>
    this.sloApi.requestUpdate(observationId);
  finalizeSLO = (observation: SloObservationDetails) =>
    this.sloApi.finalizeSLO(observation);

  // PMs
  createPM = (sloId: string, performanceMeasure: SloPerformanceMeasure) =>
    this.sloApi.createPM(sloId, performanceMeasure);

  updatePM = (performanceMeasure: SloPerformanceMeasure) =>
    this.sloApi.updatePM(performanceMeasure);

  deletePM = (performanceMeasureId: number) =>
    this.sloApi.deletePM(performanceMeasureId);

  // PIs
  createPI = (performanceIndicator: SloPerformanceIndicator) =>
    this.sloApi.createPI(performanceIndicator);

  updatePI = (performanceIndicator: SloPerformanceIndicator) =>
    this.sloApi.updatePI(performanceIndicator);

  deletePI = (performanceIndicatorId: number) =>
    this.sloApi.deletePI(performanceIndicatorId);

  // SLO Comments
  getSloComments = (sloId: string) =>
    this.sloApi.getSloComments(sloId);

  rollbackSloState = (sloId: string, newState: number) =>
    this.sloApi.rollbackSloState(sloId, newState);
}
